// Safari и WebView на macOS/iOS начинают читать Blob уже после click(): пока
// файл сохраняется, ссылка должна оставаться живой. Немедленный
// revokeObjectURL обрывал сохранение больших файлов на полпути.
const OBJECT_URL_LIFETIME_MS = 60000;

const isObjectUrl = (value) => typeof value === "string" && value.startsWith("blob:");

export const downloadFile = (source, filename) => {
    const isBlob = typeof Blob !== "undefined" && source instanceof Blob;
    const href = isBlob ? URL.createObjectURL(source) : source;

    const anchor = document.createElement("a");
    anchor.href = href;
    anchor.download = filename || "file";
    anchor.rel = "noopener";
    anchor.style.display = "none";

    document.body.appendChild(anchor);
    anchor.click();

    setTimeout(() => anchor.remove(), 0);
    if (isBlob || isObjectUrl(href)) {
        setTimeout(() => URL.revokeObjectURL(href), OBJECT_URL_LIFETIME_MS);
    }

    return href;
};
